var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "frontali" } },
    [
      _c(
        "div",
        { staticClass: "toolbar", class: { dark: _vm.darkTheme } },
        [
          _c(
            "v-layout",
            { staticClass: "items-center selected-bar align-center" },
            [
              _vm.config.frontali_search
                ? _c(
                    "div",
                    { staticClass: "textfield-container select-layout" },
                    [
                      _c(
                        "v-text-field",
                        {
                          staticClass: "text-input",
                          staticStyle: { "padding-top": "8px" },
                          attrs: {
                            variant: "underlined",
                            clearable: "",
                            "append-icon": "search",
                          },
                          model: {
                            value: _vm.query,
                            callback: function ($$v) {
                              _vm.query = $$v
                            },
                            expression: "query",
                          },
                        },
                        [
                          _c("template", { slot: "label" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("message.Cerca")) +
                                  " (" +
                                  _vm._s(_vm.filteredItems.length) +
                                  " models)"
                              ),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.config.frontali_marchio
                ? _c(
                    "div",
                    { staticClass: "marchio select-layout" },
                    [
                      _c("v-select", {
                        attrs: {
                          "menu-props": {
                            offsetY: true,
                            top: false,
                            maxHeight: "20%",
                          },
                          items: _vm.lineNames,
                          "item-text": "title",
                          "item-value": "value",
                          dense: "",
                          "hide-details": "",
                          label: "Brand",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "selection",
                              fn: function ({ item, index }) {
                                return [
                                  index < 1
                                    ? _c("v-chip", [
                                        _c("span", [
                                          _vm._v(_vm._s(item.title)),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  index === 1
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-grey text-caption align-self-center",
                                        },
                                        [
                                          _vm._v(
                                            " (+" +
                                              _vm._s(_vm.marchio.length - 1) +
                                              " others) "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2679190315
                        ),
                        model: {
                          value: _vm.marchio,
                          callback: function ($$v) {
                            _vm.marchio = $$v
                          },
                          expression: "marchio",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.btActive
                ? _c(
                    "div",
                    { staticClass: "misura select-layout" },
                    [
                      _c("v-select", {
                        attrs: {
                          "menu-props": {
                            offsetY: true,
                            top: false,
                            maxHeight: "20%",
                          },
                          inputmode: "none",
                          clearable: "",
                          items: _vm.formattedItemSizes,
                          "item-text": "text",
                          "item-value": "id",
                          dense: "",
                          "hide-selected": "",
                          "hide-details": "",
                          label: _vm.$t("message.Misura"),
                        },
                        model: {
                          value: _vm.selectedSize,
                          callback: function ($$v) {
                            _vm.selectedSize = $$v
                          },
                          expression: "selectedSize",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "forma select-layout" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.availableShapes,
                      "item-text": "text",
                      "item-value": "id",
                      clearable: "",
                      dense: "",
                      "hide-details": "",
                      label: _vm.$t("message.Forma"),
                    },
                    model: {
                      value: _vm.selectedShape,
                      callback: function ($$v) {
                        _vm.selectedShape = $$v
                      },
                      expression: "selectedShape",
                    },
                  }),
                ],
                1
              ),
              _vm.config.fronatli_tipologia
                ? _c(
                    "div",
                    { staticClass: "tipologia select-layout" },
                    [
                      _c("v-select", {
                        attrs: {
                          "menu-props": {
                            offsetY: true,
                            top: false,
                            maxHeight: "20%",
                          },
                          inputmode: "none",
                          "deletable-chips": "",
                          items: _vm.frontTypeOptions,
                          "item-text": "text",
                          "item-value": "id",
                          dense: "",
                          "hide-selected": "",
                          "hide-details": "",
                          label: _vm.$t("message.Tipologia"),
                        },
                        model: {
                          value: _vm.selectedFrontType,
                          callback: function ($$v) {
                            _vm.selectedFrontType = $$v
                          },
                          expression: "selectedFrontType",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.config.frontali_asianFitting
                ? _c(
                    "div",
                    { staticClass: "select-layout", attrs: { shrink: "" } },
                    [
                      _c("v-switch", {
                        staticClass: "asian-fitting-switch",
                        staticStyle: { "min-width": "118px" },
                        attrs: {
                          color: "primary",
                          label: _vm.asianFittingText,
                        },
                        model: {
                          value: _vm.asianFitting,
                          callback: function ($$v) {
                            _vm.asianFitting = $$v
                          },
                          expression: "asianFitting",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c("ItemsCarousel", {
        attrs: {
          itemsType: _vm.itemsType,
          itemsCarousel: _vm.filteredItems,
          itemsWrap: _vm.config.frontali_wrap,
          activeElement: _vm.activeModelCode,
        },
        on: { "item-selected": _vm.setFrame },
      }),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "570" },
          model: {
            value: _vm.showSunModelNotAvailable,
            callback: function ($$v) {
              _vm.showSunModelNotAvailable = $$v
            },
            expression: "showSunModelNotAvailable",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "pt-2 px-2", attrs: { shaped: "" } },
            [
              _c("v-card-title", { staticClass: "bg-warning" }, [
                _c(
                  "h3",
                  {
                    staticStyle: { "word-break": "break-word" },
                    attrs: { color: "white" },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("message.Attenzione")) + " ")]
                ),
              ]),
              _c("v-card-text", { staticClass: "pb-0" }, [
                _c("h4", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "message.Questo_modello_non_è_disponibile_nella_versione_da_sole**_Verrai_ora_riportato_agli_occhiali_da_vista**"
                        )
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-layout",
                    {
                      staticStyle: { gap: "10px", margin: "0" },
                      attrs: { wrap: "", "justify-end": "" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.showSunModelNotAvailable = false
                              _vm.selectedFrontType = "V"
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm._f("upperCase")(_vm.$t("message.ok")))
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "500" },
          model: {
            value: _vm.noSizeSelectedDialog,
            callback: function ($$v) {
              _vm.noSizeSelectedDialog = $$v
            },
            expression: "noSizeSelectedDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "bg-warning" },
                [
                  _c(
                    "v-btn",
                    { attrs: { icon: "" } },
                    [_c("v-icon", [_vm._v("warning")])],
                    1
                  ),
                  _c("v-spacer"),
                  _c("h2", { attrs: { color: "white" } }, [
                    _vm._v("Nessuna misura selezionata"),
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticStyle: { top: "0", right: "0" },
                      attrs: { icon: "", absolute: "" },
                      on: {
                        click: function ($event) {
                          _vm.noSizeSelectedDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "no-size-dialog d-flex flex-column",
                      attrs: {
                        wrap: "",
                        "justify-center": "",
                        "align-center": "",
                        "fill-height": "",
                      },
                    },
                    [
                      _c("v-flex", {}, [
                        _vm.frontale
                          ? _c(
                              "h3",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm.$t("message.modello")
                                      )
                                    ) +
                                    ": " +
                                    _vm._s(_vm.frontale.ModelName) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _c(
                        "v-flex",
                        {
                          staticClass: "d-flex flex-column",
                          attrs: { "justify-center": "" },
                        },
                        [
                          _c(
                            "h3",
                            {
                              staticClass: "mt-5 mb-2",
                              staticStyle: {
                                margin: "0px",
                                "text-align": "center",
                              },
                            },
                            [_vm._v(" Seleziona una misura: ")]
                          ),
                          _c(
                            "v-btn-toggle",
                            {
                              staticClass: "d-flex justify-center",
                              attrs: { block: "", large: "" },
                              model: {
                                value: _vm.selectedSize,
                                callback: function ($$v) {
                                  _vm.selectedSize = $$v
                                },
                                expression: "selectedSize",
                              },
                            },
                            _vm._l(_vm.itemSizes, function (size) {
                              return _c(
                                "v-btn",
                                {
                                  key: size.id,
                                  staticClass: "size-option flex-1",
                                  attrs: { large: "", value: size.id },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        parseInt(size.size_eye) +
                                          "/" +
                                          parseInt(size.size_bridge)
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }